import "@/styles/index.css";

import siteHeader from "@/scripts/components/site-header";
import scrollReveal from "@/scripts/components/scroll-reveal";
import parallaxShape from "@/scripts/components/parallax-shapes";
import scrollTo from "@/scripts/components/scroll-to";
import form from "@/scripts/components/form/form";
import mobileBar from '@/scripts/components/mobile-bar';

import Alpine from "alpinejs";

siteHeader.init();
scrollReveal.init();
parallaxShape.init();
scrollTo.init();
form.init();
mobileBar.init();

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('_preload')
  }, 250)
})
